/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable no-sequences */
import React from "react";
import Components from "mpm-components";
import Services from "mpm-services";
import {
  Form,
  Button,
  Icon,
  Divider,
  Grid,
  FormTextArea,
} from "semantic-ui-react";
import Utilities from "mpm-config/Utilities";
import MPMContext from "mpm-config/context/MPMContext";
import { SourceCP } from "mpm-classes/CessionProduit";
import { toClass } from "class-converter";
import NumberFormat from "react-number-format";

export default ({ cessionProduit, onChangeListSources, setMessage, editMode, onComplet }) => {

  const [checkedSourceCPList, setCheckedSourceCPList] = React.useState([]);
  const [loadingSource, setLoadingSource] = React.useState(false);
  const [savingSourceCP, setSavingSourceCP] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(false);
  const [modalData, setModalData] = React.useState({ open: false })
  const [source, setSource] = React.useState(new SourceCP())
  const [sourceIndex, setSourceIndex] = React.useState(cessionProduit.childrenSourceCP ? cessionProduit.childrenSourceCP.length : 0);
  const [sourceError, setSourceError] = React.useState(false);
  const [sourceEspeceCriteria, setSourceEspeceCriteria] = React.useState({refEspece: null, refTransf: null, augDimun : 1, taux: 0, loading: false, disabled: false});

  const onChangeSource = (name, value) => {
    let _source = source;
    _source = {
      ...source,
      [name] : value
    }
    setSourceError(false)
    let found = false
    cessionProduit.childrenSourceCP.forEach(elem => {
      if(elem.typeSource === _source.typeSource && elem.codeSource === _source.codeSource){
        found = true
      }
    })
    if(found){
      setSourceError(true)
    }
    setSource(_source);

  }

  const onAddSource = () => {
    setIsEdit(false);
    setSource(new SourceCP())
    setSourceIndex(cessionProduit.childrenSourceCP ? cessionProduit.childrenSourceCP.length : 0);
  };

  const onLoadSource = () => {
    if (
      Utilities.isNotNull(cessionProduit.dateCession) &&
      Utilities.isNotNull(source.typeSource) && 
      Utilities.isNotNull(source.codeSource)) {
      setLoadingSource(true);
      setMessage(null)
      Services.CessionsProduitDataService.chargerSourceCP({
        dateCession: cessionProduit.dateCession,
        typeSource: source.typeSource,
        codeSource: source.codeSource,
        categoriePeche: cessionProduit.categoriePeche
      })
        .then((result) => {
          setLoadingSource(false);
          if (!result.success) {
            setMessage({
              error: true,
              header: "Chargement de source",
              content: result.message,
            });
            setSource(new SourceCP());
            return;
          } 
          setSourceEspeceCriteria({...sourceEspeceCriteria, disabled : false})
          let _result = {...result, allChildrenSrcEsp : result.childrenSrcEsp, childrenSrcEsp : []};
          _result.allChildrenSrcEsp.map(espece => {
            espece.id = null; 
            espece.rendementGH = espece.rendementG;
            return espece
          });
          constructDelaisNineDays([_result]);
          setSource(new SourceCP());
          setTimeout(() => {
            setSource(toClass(_result, SourceCP));
          }, 100);
          
        })
        .catch((error) => {
          setMessage({
            error: true,
            header: "Chargement de source",
            content: `Une erreur est survenue lors de chargement de la source ${source.codeSource}`,
          });
          setLoadingSource(false);
        });
    }
  };
  const constructDelaisNineDays = (rows = []) => {
    let messages = [];

    rows.forEach(elem => {
      if(Utilities.isNotNull(elem.message)){
        messages.push(elem.message);
      }
    })
    if(messages.length > 0){
      setMessage({
        error : true,
        header: "Attention !!",
        content: messages,
        isArrray: true
      })
    }
  }
  const onSelectEspeces = (selectedEspeces) => {
    let _source = {
      ...source,
      childrenSrcEsp : [...selectedEspeces]
    };
    let allChild = [];
     _source.allChildrenSrcEsp.forEach((elem) => {
      let _in = selectedEspeces.indexOf(elem);
      if(_in !== -1){
        elem = selectedEspeces[_in]
        if(elem.poidCD === 0){
          elem.poidCD = elem.disponible;
          elem.quantite = elem.poidCD * elem.rendementGH
        }
       }else{
        elem.poidCD = Number(0);
        elem.quantite = Number(0)
          
       }
      allChild.push(elem);
    })
    _source = {
      ..._source, 
      allChildrenSrcEsp : [...allChild]
    }
    setSource(_source);
  }

  const onChangeEspeceQuantite = (espece, value) => {
   
    let _source = {...source};
    let index = _source.allChildrenSrcEsp.indexOf(espece);

    
    let nextValue = Number(value.split(" ").join(""));
    let qut = nextValue; 
      let pcD = qut / espece.rendementG;
      if(pcD <= espece.disponible) {
        espece.quantite = qut;
        if (espece.rendementG === 1 ) {
          espece.poidCD = espece.quantite
        } else {
            espece.poidCD = pcD
        }
      }
    _source.allChildrenSrcEsp[index] = espece;
    _source.childrenSrcEsp = _source.allChildrenSrcEsp.filter(item => item.selected);
    setSource({
      ..._source,
    });
  };
  const onChangeEspecePoidCD = (espece, value) => {
   
    let _source = {...source};
    let index = _source.allChildrenSrcEsp.indexOf(espece);
    let nextValue = Number(value.split(" ").join(""));
    let pcD = nextValue;
      let qut = pcD * espece.rendementG;
      if(pcD <= espece.disponible) {
        espece.poidCD = pcD;
        if (espece.rendementG === 1 ) {
          espece.quantite = espece.poidCD
        } else {
            espece.quantite = qut;
        }
      }
    _source.allChildrenSrcEsp[index] = espece;
    _source.childrenSrcEsp = _source.allChildrenSrcEsp.filter(item => item.selected);
    setSource({
      ..._source,
    });
  }; 
  const getSourceCPList = (sourceCP) => {
    if (sourceCP) {
      let tab = [];
      if (sourceCP.id_refDeclarationPeche && tab.indexOf(sourceCP.id_refDeclarationPeche) === -1) {
        tab.push(sourceCP.id_refDeclarationPeche);
      }
      if (sourceCP.id_refCessionCap && tab.indexOf(sourceCP.id_refCessionCap) === -1) {
        tab.push(sourceCP.id_refCessionCap);
      }
      if (sourceCP.id_refEtatAchat && tab.indexOf(sourceCP.id_refEtatAchat) === -1) {
        tab.push(sourceCP.id_refEtatAchat);
      }
      if (sourceCP.id_refCessionCapSrc && tab.indexOf(sourceCP.id_refCessionCapSrc) === -1) {
        tab.push(sourceCP.id_refCessionCapSrc);
      }
      return tab;
    }
    return [];
  };

  const onSaveSourceCP = () => {
    setMessage(null);
    let _source = {...source};
    let messages =  []
    _source.childrenSrcEsp.forEach(elem => {
      if(!(Utilities.isNumber(elem.quantite) && elem.quantite > 0)){
        messages.push(`Quantité cédée ${elem.quantite} pour l'espece ${elem.refEspece.libelle} est invalide`)
      }
    });
    if(messages && messages.length > 0){
      setMessage({
        warning: true,
        header: "Validation Especes",
        content: messages,
      });
    }else{
      setSavingSourceCP(true);
      Services.CessionsProduitDataService.saveSourceCP({ ..._source, id_RefTypeSource : _source.typeSource })
        .then((result) => {
          if (result.success) {

            updateStore(_source);
            onAddSource();
          } else {
            setMessage({
              warning: true,
              header: "Enregistrement source",
              content: result.message,
            });
          }
          setSavingSourceCP(false);
        })
        .catch((error) => {
          setMessage({
            error: true,
            header: "Enregistrement source",
            content:
              "Une erreur est survenue lors d'enregistrement de la source",
          });
          setSavingSourceCP(false);
        });
    }
    
  };

  const onEditSource = (_source) => {
    setIsEdit(true);
    setSource(new SourceCP());
    const index = cessionProduit.childrenSourceCP.indexOf(_source)
    setTimeout(() => {
      setSourceIndex(index);
      if(editMode){
        _source.allChildrenSrcEsp = _source.childrenSrcEsp;
        setSourceEspeceCriteria({...sourceEspeceCriteria, disabled : true})
      }else{
        setSourceEspeceCriteria({...sourceEspeceCriteria, disabled : false})
      }
      setSource(_source);
    }, 50);
  };

  const onDeleteSource = (_source) => {

    let cc = cessionProduit;
    
    setModalData({...modalData, loadingConfirm: true})
    if(cc.etat === "0"){
      let totalIds = cc.childrenSourceCP && cc.childrenSourceCP.map(elem => elem.id).flat().filter(elem => elem);
      if(editMode && totalIds && _source.id && totalIds.length === 1){
        Services.CessionsProduitDataService.delete({ id: cc.id, etat: cc.etat }).then(result => {
          setModalData({open: false})
          if(result.success){
            setMessage({
              success: true,
              header: "Suppression cession de produit",
              content: "Cession de capture a été supprimer avec succée."
            });
            onComplet(true);
          }else{
            setMessage({
              error: true,
              header: "Suppression de la source",
              content: result.message
            });
          }
        }).catch(error => setMessage({
          error: true,
          header : "Suppression de la source",
          content: "Erreur lors de suppression de la source"
        }));
        return
      }else{
        if(_source.id){
          Services.CessionsProduitDataService.deleteSourceCP(_source.id).then(result => {
            if(result.success){
              afterDeleteSuccess(cc, _source)
            }else{
              setModalData({open: false})
            setMessage({
              error: true,
              header : "Suppression de la source",
              content: result.message
            })
            }
          }).catch(error => {
            setModalData({open: false})
            setMessage({
              error: true,
              header : "Suppression de la source",
              content: "Erreur lors de suppression de la source"
            })
          })
        }else{
          afterDeleteSuccess(cc, _source)
        }
      }
      

    }else{
     afterDeleteSuccess(cc, _source)
    }
    setIsEdit(false);
    setSource(new SourceCP())
    setSourceIndex(cessionProduit.childrenSourceCP.length);
  };

  const afterDeleteSuccess = (cc, source) => {
    let newChecked = [...checkedSourceCPList];
    let index = cc.childrenSourceCP.indexOf(source)
    let _sourceCPList = getSourceCPList(source);
    cc.childrenSourceCP.map(elem => {
      _sourceCPList.forEach(ss => {
        elem.sourceCPList.splice(elem.sourceCPList.indexOf(ss), 1);
        newChecked.splice(newChecked.indexOf(ss), 1)
      });
      return elem
    })
    setModalData({open: false})
    setCheckedSourceCPList(newChecked)
    cc.childrenSourceCP.splice(index, 1);
    if(cc.childrenSourceCP.length === 0){
      cc.categoriePeche = null
    }
    onChangeListSources({...cc});
  }

  const updateStore = (_source, activePush= true) => {
    let _newCessionProduit = {...cessionProduit };
    if(_newCessionProduit.childrenSourceCP[sourceIndex] !== undefined){
      _newCessionProduit.childrenSourceCP[sourceIndex] = _source;
    }else{
      _newCessionProduit.childrenSourceCP.push(_source);
    }
    if(!_newCessionProduit.categoriePeche){
      _newCessionProduit.categoriePeche = _source.categoriePeche;
    }
    
    onChangeListSources({..._newCessionProduit});
  };

  const getDeleteContent = (cession, clickedSource) => {
    let deleteCession = false
    if(editMode){
      deleteCession = clickedSource.id && cession.childrenSourceCP.map(elem => elem.id).flat().filter(elem => elem).length === 1;
    }else{
      deleteCession = clickedSource.id && cession.childrenSourceCP.length === 1;
    }
    if(deleteCession){
      return "Êtes vous sur de bien vouloir supprimer cette source ? Attention la cession de produit va être supprimer !!";
    }else{
      return "Êtes vous sur de bien vouloir supprimer cette source ? ";
    }
  }
  
  return (
    <MPMContext.Consumer>
      {(context) => (
        <>
          <Grid columns="equal">
          <Grid.Column computer={5}mobile={16}>
              <Components.Regions.RegionWithHeader
                title="label.sources"
                headerColor="blue"
                headerSize="small"
               
              >
               <Components.Tables.SmartTable 
                header={[
                  {
                    selector: "codeSource",
                    collapsing : false,
                    label: "Source",
                    positive: (row) => !row.id,
                    component: (row) => (
                      <>{Utilities.getTypeSourceName(row.typeSource)} <br /> {row.codeSource}</>
                    ),
                  },{
                    selector: "codeSource",
                    collapsing: true,
                    label: "Actions",
                    positive: (row) => !row.id,
                    component: (row) => (
                      <Button.Group size="mini">
                        <Button
                          onClick={() => onEditSource(row)}
                          icon
                        >
                          {editMode ? <Icon name="eye" /> : <Icon name="edit" />}
                        </Button>
                        <Button
                          icon
                          negative
                          onClick={() => setModalData({ data: row, open: true, title: "Confirmation de supression", content: getDeleteContent(cessionProduit, row), loadingConfirm: false })}
                        >
                          <Icon name="trash" />
                        </Button>
                      </Button.Group>
                    ),
                  }]}
                  data={cessionProduit.childrenSourceCP}
                  selectable={false}
                  grouped={false}
                  pagination={true}
                  rowsPerPage={5}
                  striped={true}
                  sortable={true}
              />
              </Components.Regions.RegionWithHeader>
            </Grid.Column>
            <Grid.Column>
              <Components.Regions.RegionWithoutHeader>
                  <Form size="small">
                    <Form.Group widths="equal">
                      <Form.Dropdown
                        label="Type Source"
                        selection
                        disabled={isEdit}
                        value={source.typeSource}
                        options={Utilities.getCPTypeSourceDropDownOptions()}
                        onChange={(event, { value }) =>  onChangeSource("typeSource", value) }
                      />
                      <Form.Input
                        label="Code Source"
                        name="codeSource"
                        size="small"
                        disabled={isEdit}
                        error={sourceError}
                        value={source.codeSource}
                        onChange={({ target }) => onChangeSource('codeSource', target.value) }
                        action={
                          <Button disabled={sourceError} loading={loadingSource} onClick={() => onLoadSource()} positive >
                            Charger
                          </Button>
                        }
                      />
                    </Form.Group>
                  </Form>
              </Components.Regions.RegionWithoutHeader>
            </Grid.Column>
          </Grid>
          <Grid columns="equal">
            <Grid.Column>
              <Components.Regions.RegionWithHeader
                title="label.especes"
                headerColor="blue"
                headerSize="small"
                className="scrolling-x"
              >
                {source.allChildrenSrcEsp &&
                  source.allChildrenSrcEsp.length >
                    0 && <Components.Tables.SmartTable
                    header={[
                      {
                        selector: "sourceDetail",
                        label: "Source",
                        component: (row) => (
                          <FormTextArea disabled={editMode} value={row.sourceDetail} rows={2} />
                        ),
                      },
                      {
                        selector: "refEspece.libelle",
                        label: "Espece",
                      },
                      
                      {
                        selector: "disponible",
                        textAlign: "center",
                        label: "Disponible en (KG)",
                        component: (row) => <NumberFormat min={0} customInput={Form.Input} displayType={"text"} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={'.', ','} value={row.disponible} />
                      },
                      {
                        selector: "refTypeTransf.nom",
                        textAlign: "center",
                        label: "Transformation",
                        
                      },
                      {
                        selector: "autreTrans",
                        textAlign: "center",
                        label: "Autre Trans",
                      },
                      {
                        selector: "quantite",
                        label: "Quantité cédée en (KG)",
                        component: (row) => (
                          <NumberFormat min={0} customInput={Form.Input} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={'.', ','}
                            disabled={editMode && isEdit}
                            error={!Utilities.isNumber(row.quantite) || row.quantite === 0}
                            value={row.quantite}

                            onChange={(evt) => onChangeEspeceQuantite(row, evt.target.value)}

                            /* onValueChange={(values) => {
                              const {formattedValue, value} = values;
                              onChangeEspeceQuantite(row, value)
                            }} */
                          />
                        ),
                      },
                      {
                        selector: "poidCD",
                        grow: 1,
                        label: "Poids CD (KG)",
                        component: (row) => (
                          <NumberFormat min={0} customInput={Form.Input} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={'.', ','} 
                            disabled={editMode && isEdit}
                            value={row.poidCD}
                            error={!Utilities.isNumber(row.poidCD) || row.poidCD === 0}
                            onChange={(evt) => onChangeEspecePoidCD(row, evt.target.value)}

                            /* onValueChange={(values) => {
                              const {formattedValue, value} = values;
                              onChangeEspecePoidCD(row, value)
                            }} */
                          />
                        ),
                      },
                      {
                        selector: "rendementG",
                        textAlign: "center",
                        label: "Rendement G",
                        component: (row) => <NumberFormat min={0} customInput={Form.Input} displayType={"text"} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={'.', ','} value={row.rendementG} />
                       
                      },
                      {
                        selector: "rendementT",
                        textAlign: "center",
                        label: "Rendement T",
                        component: (row) => <NumberFormat min={0} customInput={Form.Input} displayType={"text"} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={'.', ','} value={row.rendementT} />
                      },
                    ]}
                    data={source.allChildrenSrcEsp}
                    selectable={!editMode || !isEdit}
                    grouped={false}
                    pagination={true}
                    rowsPerPage={5}
                    striped={true}
                    sortable={true}
                    onSelectRows={(rows) => onSelectEspeces(rows)}
                  />}

                {source.childrenSrcEsp && source.childrenSrcEsp.length > 0 && (
                  <>
                    <Divider />
                    <Components.Tables.SmartTable
                      header={[
                        {
                          selector: "refEspece.libelle",
                          label: "Espece",
                        },
                        {
                          selector: "disponible",
                          label: "Total Disponible en (KG)",
                          component: (row) => <NumberFormat min={0} customInput={Form.Input} displayType={"text"} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={'.', ','} value={row.disponible} />

                        },
                        {
                          selector: "quantite",
                          label: "Total Quantité cédée en (KG)",
                          component: (row) => <NumberFormat min={0} customInput={Form.Input} displayType={"text"} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={'.', ','} value={row.quantite} />

                        },
                        {
                          selector: "poidCD",
                          label: "Total Poids CD en (KG)",
                          component: (row) => <NumberFormat min={0} customInput={Form.Input} displayType={"text"} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={'.', ','} value={row.poidCD} />

                        },
                      ]}
                      data={source.childrenSrcEsp}
                      grouped={true}
                      groupeBy="refEspece.libelle"
                      groupeSums={["disponible", "quantite", "poidCD"]}
                      rowsPerPage={5}
                      pagination={true}
                      striped={true}
                      sortable={false}
                      selectable={false}
                    />
                    <Button
                      floated="right"
                      loading={savingSourceCP}
                      disabled={source.childrenSrcEsp.length === 0 }
                      onClick={() => onSaveSourceCP()}
                      icon
                      primary
                      size="mini"
                    >
                      <Icon name="plus" />
                    </Button>
                  </>
                )}
              </Components.Regions.RegionWithHeader>
            </Grid.Column>
          </Grid>
          {modalData && <Components.Modals.Confirmation modalData={modalData} onConfirm={(data) => onDeleteSource(data)} onCancel={() => setModalData({ open: false })} />}
        </>
      )}
    </MPMContext.Consumer>
  );
};
